// 9fbef606107a605d69c0edbcd8029e5d

export const COLLECTIONS_LABELS = 'CollectionsLabels.CollectionsLabels_Sub';

export const collectionsLabels = {
  CollectionsLabels: {
    CollectionsLabels_Sub: {
      lbl_add_another: 'Add Another',
      lbl_build_your_experience_department_body:
        'Begin by selecting family members you would like to shop for. You may select multiple at a time.',
      lbl_build_your_experience_department_header: 'Build your collection',
      lbl_build_your_experience_entry_body: 'Add family members, choose styles, and add it to bag!',
      lbl_build_your_experience_entry_cta: 'Start here',
      lbl_build_your_experience_entry_header: 'Want to build your collection?',
      lbl_remove_item: 'Remove Item',
      lbl_see_full_details: 'See Full Details',
      lbl_added: 'added',
      lbl_selected: 'selected',
      lbl_total_items: 'Total Items',
      lbl_add_x_to_bag: 'Add (##) to Bag',
      lbl_item_oos: 'This item is currently out of stock.',
      lbl_all_item_oos: 'There was an error adding your items to the cart. Please try again!',
    },
  },
};
